import Banner from 'assets/images/banner.png';
import Navbar from 'components/global/navbar';

const Hero = () => {
    return (
        <div className='relative h-screen overflow-hidden'>
            <div className='relative z-10'>
                <Navbar />
            </div>
            <div className='absolute top-1/2 -translate-y-1/2 w-full lg:px-20 md:px-12 sm:px-8 px-4  flex flex-col justify-center'>
                <h1 className='md:text-[45px] lg:w-[60%] md:w-[80%] sm:w-[90%] w-full sm:text-[35px] text-[25px] lg:leading-[1.5] sm:font-bold font-semibold'>
                    Over <span className='text-primary'>70 billion</span> impressions on 100,0000 + screens.
                </h1>
                <ul className='list-disc md:ml-8 ml-4 mt-6 text-dark flex flex-col gap-1.5 sm:text-base text-[15px]'>
                    <li>
                    Explore the scale of reach and the wide variety of inventory available for purchase.
                    </li>
                    <li>All inventory is programmatically connected with over 600,000 video-enabled screens.</li>
                    <li className='mt-12 text-primary font-semibold'>View our inventory by venue type, map, or DMA, by clicking on one of the tabs below</li>
                </ul>
            </div>
            <div className='absolute top-0 right-0 flex items-end justify-end -z-[2]'>
                <img src={Banner} alt="Banner bg" className='w-[90%]' />
            </div>
        </div>
    )
}

export default Hero